// removed by extract-text-webpack-plugin
module.exports = {"app":"index__app___26ET2","contacts":"index__contacts___3dDOm","link":"index__link___3pCFe","icon":"index__icon___GZaNm"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/App/index.styl
 ** module id = 203
 ** module chunks = 0
 **/